const $$splitComponentImporter = () => import('/home/runner/work/nexus/nexus/apps/frontend/src/routes/(app)/org/$org/settings/containers/$containerId/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
import { Spinner } from '@tempo-io/sui-spinner';
import i18n from '@/lib/translations/i18n';
export const Route = createFileRoute('/(app)/org/$org/settings/containers/$containerId/')({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  loader: async (): Promise<LoaderData> => {
    return {
      crumb: i18n.t($ => $.common.settings.boxes.boxSettings.label)
    };
  },
  pendingComponent: () => <div className="flex items-center justify-center h-full">
      <Spinner size={32} />
    </div>,
  staticData: {
    topNav: {
      title: i18n.t($ => $.common.settings.boxes.boxSettings.label)
    }
  }
});